/* eslint-disable */

export const AVAILABLE_PAIRS_CONSTANTS = {
    GET_AVAILABLE_PAIRS_REQUEST: 'GET_AVAILABLE_PAIRS_REQUEST',
    GET_AVAILABLE_PAIRS_SUCCESS: 'GET_AVAILABLE_PAIRS_SUCCESS',
    GET_AVAILABLE_PAIRS_FAILURE: 'GET_AVAILABLE_PAIRS_FAILURE',
};
